import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/shoppingCart";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import Transition from "../../stateless/Transition";

const DeleteProductFromCart = ({
  onClose,
  open,
  product,
  removeItemFromCart,
  shoppingCart: { cart },
}) => {
  const [itemsToDelete, setitemsToDelete] = useState(0);

  const handleInputText = ({ target: { value } }) => setitemsToDelete(value);

  const handleRemoveProductsFromCart = async () => {
    let itemsFiltered = [];
    switch (product.productTypeId) {
      case "1":
        itemsFiltered = Object.values(cart).filter(
          (item) => item.movileId !== null
        );
        break;
      case "2":
        itemsFiltered = Object.values(cart).filter(
          (item) => item.accesoryId !== null
        );
        break;
      case "4":
        itemsFiltered = Object.values(cart).filter(
          (item) => item.cashCardId !== null
        );
        break;

      default:
        break;
    }
    for (let index = 0; index < itemsToDelete; index++) {
      removeItemFromCart({ item: itemsFiltered[index] });
    }
    handleClose();
  };

  const handleClose = () => onClose();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Eliminar productos del carrito
      </DialogTitle>
      <DialogContent>
        <TextField
          id="standard-number"
          InputProps={{ inputProps: { min: 0, max: product.units } }}
          label="Cantidad"
          type="number"
          onChange={(e) => handleInputText(e)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <ConfirmButtons
          cancel={handleClose}
          acceptTitle="Confirmar"
          accept={handleRemoveProductsFromCart}
        />
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  removeItemFromCart: actions.removeItemFromCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(DeleteProductFromCart);
